import { relations } from 'drizzle-orm'
import { boolean, index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema } from 'drizzle-zod'

import { user } from '../auth'
import { LessonModule } from '../content'

// =============================================================================
// LESSON MODULE VIEW - Event table (one row per view)
// Aggregated into LessonModule.viewsCount by `cron / lesson-module-metrics / total-views`.
// userId nullable so anonymous/public views are still counted.
// =============================================================================

export const LessonModuleView = pgTable(
  'lesson_module_view',
  {
    id: uuid().primaryKey().defaultRandom(),
    userId: text().references(() => user.id, { onDelete: 'set null' }),
    lessonModuleId: uuid()
      .references(() => LessonModule.id, { onDelete: 'cascade' })
      .notNull(),
    calculatedForMetrics: boolean().default(false).notNull(),
    metricsCalculatedAt: timestamp({ mode: 'date', withTimezone: true }),
    calculatedForMonthlyMetrics: boolean().default(false).notNull(),
    monthlyMetricsCalculatedAt: timestamp({ mode: 'date', withTimezone: true }),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
  },
  (t) => [
    index('idx_lesson_module_view_user').on(t.userId),
    index('idx_lesson_module_view_module').on(t.lessonModuleId),
    index('idx_lesson_module_view_calculated').on(t.calculatedForMetrics),
    index('idx_lesson_module_view_monthly_calculated').on(t.calculatedForMonthlyMetrics),
    index('idx_lesson_module_view_created_at').on(t.createdAt),
  ],
)

export const lessonModuleViewRelations = relations(LessonModuleView, ({ one }) => ({
  lessonModule: one(LessonModule, {
    fields: [LessonModuleView.lessonModuleId],
    references: [LessonModule.id],
  }),
  user: one(user, {
    fields: [LessonModuleView.userId],
    references: [user.id],
  }),
}))

export const InsertLessonModuleViewSchema = createInsertSchema(LessonModuleView).omit({
  id: true,
  calculatedForMetrics: true,
  metricsCalculatedAt: true,
  createdAt: true,
})

export const SelectLessonModuleViewSchema = createSelectSchema(LessonModuleView)

export type InsertLessonModuleView = typeof LessonModuleView.$inferInsert
export type SelectLessonModuleView = typeof LessonModuleView.$inferSelect
